export default "__VITE_ASSET__BPMym4vU__"